import styled from 'styled-components';

export const StyledFieldInput = styled.input`
  appearance: none;
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[5]};
  border: none;
  box-shadow: ${(p) => p.theme.shadows.all};
  height: ${(p) => p.theme.space[7]};
  width: 100%;
  border-radius: ${(p) => p.theme.radii.pill};

  &:disabled {
    color: ${(p) => p.theme.alias.subtle};
    border-color: ${(p) => p.theme.alias.shadow};
    background-color: ${(p) => p.theme.colors.slate[2]};
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusOuter};
  }
`;
